<template>
  <BittsButton
    :text="actionText"
    type="neutral"
    variant="outline"
    size="small"
    :left-icon="actionIcon"
    @click="emit('action')"
  />
  <BittsButton
    type="neutral"
    variant="outline"
    size="small"
    :center-icon="['fas', 'ellipsis']"
    :aria-label="`More actions for ${resourceName}`"
  />
</template>

<script setup lang="ts">
import { BittsButton } from '@crossbeam/bitts';
import type { BittsIcon } from '@crossbeam/bitts';

defineProps<{
  actionText: string;
  actionIcon: BittsIcon;
  resourceName: string;
}>();

const emit = defineEmits<{
  action: [];
}>();
</script>
